// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3kSFU","container":"styles_container__11y-U","title":"styles_title__1Ms1w","wrapper":"styles_wrapper__1ryGg","answer":"styles_answer__3VhLs"};